import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class InstanceServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getList(params) {
    return super.getList({ ...params });
  }
  getAllItems() {
    return super.getList();
  }
  createItem(params) {
    return this.pure_http.post('/instances', params);
  }
  getItem(id) {
    return this.http.get(`/${id}`);
  }
  editItem(id, params = {}) {
    return this.http.put(`/${id}`, params);
  }
}

export const InstanceService = new InstanceServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'instances'
});
